export const getVkAuthModel = async (containers) => {
  if (typeof vkConnect === 'undefined' || typeof vkConnectId === 'undefined') {
    return null
  }

  if (!vkConnect) { // eslint-disable-line
    return null
  }

  const { VKAuth } = await import('./VKAuthModel');
  const { VKConnect } = await import('./VKConnect');
  const { VKAuthButtons } = await import('./VKAuthButtons');

  // vkConnectId - переменная, объявленная в index.html
  const options = {
    appId: vkConnectId, // eslint-disable-line
    authAction: '/landgen/api/v1/vk-connect/exchange-token/',
    debug: false
  };

  const vkAuthModel = new VKAuth()

  new VKAuthButtons(containers, vkAuthModel).init();
  new VKConnect(options, vkAuthModel).init();

  return vkAuthModel
}
